import { DataSchema } from '@integration-app/sdk'

import Schema from './Schema'

export default function ObjectProperties({
  schema,
  level,
  onAdd,
  onChange,
}: {
  schema: DataSchema
  level: number
  onAdd: () => void
  onChange: (schema: DataSchema) => void
}) {
  if (!schema.properties) return null

  function handlePropertyChange(key, propertySchema) {
    onChange({
      ...structuredClone(schema),
      properties: {
        ...structuredClone(schema.properties),
        [key]: propertySchema,
      },
    })
  }

  function handlePropertyKeyChange(oldKey, newKey) {
    const properties = {}
    // Iterate over properties and replace old key with the new
    // to preserve the order
    /* FIXME: strictNullCheck temporary fix */
    // @ts-expect-error TS(2769): No overload matches this call.
    for (const [key, value] of Object.entries(schema.properties)) {
      if (key == oldKey) {
        properties[newKey] = value
      } else {
        properties[key] = value
      }
    }

    const newValue = {
      ...structuredClone(schema),
      properties: properties,
    }

    if (newValue.required) {
      newValue.required = newValue.required.map((pk) =>
        pk === oldKey ? newKey : pk,
      )
    }

    onChange(newValue)
  }

  function handlePropertyDelete(key: string) {
    const properties = structuredClone(schema.properties)
    if (properties?.[key]) {
      delete properties[key]
    }

    const newValue = {
      ...structuredClone(schema),
      properties,
    }

    if (newValue.required) {
      newValue.required = newValue.required.filter((pk) => pk !== key)
    }

    onChange(newValue)
  }

  function handlePropertyRequiredChange(key, required) {
    if (required) {
      onChange({
        ...structuredClone(schema),
        required: [...(schema.required ?? []), key],
      })
    } else {
      onChange({
        ...structuredClone(schema),
        required: (schema.required ?? []).filter((pk) => pk !== key),
      })
    }
  }

  const isPropertyRequiredOn = (key: string) => {
    return Array.isArray(schema.required) && schema.required.includes(key)
  }

  const propertyNames = Object.keys(schema.properties)

  const propertyList = Object.entries(schema.properties).map((prop, idx) => {
    const name = prop[0] as string
    const value = prop[1] as DataSchema

    return (
      <Schema
        key={idx}
        name={name}
        schema={value}
        isRequired={isPropertyRequiredOn(name)}
        onRequiredChange={(value) => handlePropertyRequiredChange(name, value)}
        level={level}
        onChange={(schema) => handlePropertyChange(name, schema)}
        onNameChange={(newName) => handlePropertyKeyChange(name, newName)}
        onDelete={() => handlePropertyDelete(name)}
        onAdd={onAdd}
        deprecatedNames={propertyNames.filter((n) => n !== name)}
      />
    )
  })

  return <>{propertyList} </>
}
